import { type UserTasksAndResponses } from '../../../models/userTasksAndResponses';
import { getDateOffset } from '../support/date-utils';

export const baseTasks: UserTasksAndResponses = {
  tasksCount: 6,
  termsAndConditions: {
    submitted: false,
    submissionDate: ''
  },
  firstAssessment: {
    exists: true,
    dueDate: getDateOffset(-1, 9),
    submitted: false,
    submissionDate: '',
    taskId: 'task-first-assessment'
  },
  midCohortGroupAssessment: {
    exists: true,
    dueDate: getDateOffset(-1, 9),
    submitted: false,
    submissionDate: '',
    taskId: 'task-mid-cohort'
  },
  finalGroupAssessment: {
    exists: true,
    dueDate: getDateOffset(-1, 9),
    submitted: false,
    submissionDate: '',
    taskId: 'task-final-group'
  },
  pilotGroupAssessment: {
    exists: true,
    dueDate: getDateOffset(-3, 9),
    submitted: true,
    submissionDate: getDateOffset(-2, 10),
    taskId: 'task-pilot-group'
  },
  oneOnOneFinalAssessment: {
    exists: true,
    dueDate: getDateOffset(-1, 9),
    submitted: false,
    submissionDate: '',
    taskId: 'task-one-on-one-final'
  },
  oneOnOneMidCohortAssessment: {
    exists: true,
    dueDate: getDateOffset(-1, 9),
    submitted: false,
    submissionDate: '',
    taskId: 'task-one-on-one-mid'
  }
};
